import React from "react";
import ViewerJoining from "./joining";
import ViewerViewing from "./viewing";
import Over from "../presenter//Over";

const Viewer = ({ status }) => {
  return <>{status === "Joining" ? <ViewerJoining /> : status === "Presenting" ? <ViewerViewing /> : <Over />}</>;
};

export default Viewer;
